export const CURIOUS_MEADOW_MEDIA_BUCKET = 'curious-meadow-production-media';
export const LEGACY_PROD_MEDIA_BUCKET = 'hypefury-896c7.appspot.com';
const PILOT_MEDIA_BUCKET = 'curious-meadow-media-pilot-978314735254';

export function getStorageMediaBucket(projectId, configuredStorageBucket) {
  if (projectId === 'curious-meadow') {
    return CURIOUS_MEADOW_MEDIA_BUCKET;
  }

  return configuredStorageBucket || (projectId ? `${projectId}.appspot.com` : undefined);
}

export function encodeStorageObjectName(mediaName) {
  const value = String(mediaName);

  try {
    return encodeURIComponent(decodeURIComponent(value));
  } catch (error) {
    return encodeURIComponent(value);
  }
}

export function buildFirebaseStorageMediaURL(projectId, mediaName, configuredStorageBucket) {
  const bucket = getStorageMediaBucket(projectId, configuredStorageBucket);

  return (
    `https://firebasestorage.googleapis.com/v0/b/` +
    `${bucket}/o/${encodeStorageObjectName(mediaName)}?alt=media`
  );
}

export function normalizeLegacyStorageMediaURL(url) {
  if (typeof url !== 'string') {
    return url;
  }

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') return url;

    for (const bucket of [LEGACY_PROD_MEDIA_BUCKET, PILOT_MEDIA_BUCKET]) {
      const prefixes =
        parsed.hostname === 'firebasestorage.googleapis.com'
          ? [`/v0/b/${bucket}/o/`, `/v0/b/${encodeURIComponent(bucket)}/o/`]
          : parsed.hostname === 'storage.googleapis.com'
          ? [`/${bucket}/`]
          : [];
      const prefix = prefixes.find((value) => parsed.pathname.startsWith(value));

      if (prefix) {
        const destinationPrefix =
          parsed.hostname === 'firebasestorage.googleapis.com'
            ? `/v0/b/${CURIOUS_MEADOW_MEDIA_BUCKET}/o/`
            : `/${CURIOUS_MEADOW_MEDIA_BUCKET}/`;
        parsed.pathname = destinationPrefix + parsed.pathname.slice(prefix.length);
        return parsed.toString();
      }
    }
  } catch (error) {
    return url;
  }

  return url;
}

export function normalizeThreadMediaURLs(threadData) {
  if (!threadData || typeof threadData !== 'object') {
    return threadData;
  }

  const normalizeMedia = (media) => {
    if (!media || typeof media !== 'object') {
      return media;
    }

    return {
      ...media,
      ...(typeof media.url === 'string' ? { url: normalizeLegacyStorageMediaURL(media.url) } : {}),
      ...(typeof media.thumbnail === 'string'
        ? { thumbnail: normalizeLegacyStorageMediaURL(media.thumbnail) }
        : {}),
    };
  };

  const normalizeTweet = (tweet) => ({
    ...tweet,
    media: Array.isArray(tweet.media) ? tweet.media.map(normalizeMedia) : tweet.media,
    mediaFile: Array.isArray(tweet.mediaFile) ? tweet.mediaFile.map(normalizeMedia) : tweet.mediaFile,
  });

  const tweetReel = threadData.tweetReel ? { ...threadData.tweetReel } : null;
  if (tweetReel) {
    if (typeof tweetReel.outputFileUrl === 'string') {
      tweetReel.outputFileUrl = normalizeLegacyStorageMediaURL(tweetReel.outputFileUrl);
    }
    if (tweetReel.options) {
      tweetReel.options = { ...tweetReel.options };
      if (typeof tweetReel.options.videoUrl === 'string') {
        tweetReel.options.videoUrl = normalizeLegacyStorageMediaURL(tweetReel.options.videoUrl);
      }
      if (tweetReel.options.audio) {
        tweetReel.options.audio = normalizeMedia(tweetReel.options.audio);
      }
    }
  }

  return {
    ...threadData,
    ...(tweetReel ? { tweetReel } : {}),
    tweets: Array.isArray(threadData.tweets) ? threadData.tweets.map(normalizeTweet) : threadData.tweets,
    threads:
      threadData.threads && Array.isArray(threadData.threads.posts)
        ? {
            ...threadData.threads,
            posts: threadData.threads.posts.map(normalizeTweet),
          }
        : threadData.threads,
  };
}
